<div class="metric-group" [ngClass]="makingSelectionsState==true? 'rounded-md bg-neptune-special': ''">

    <div class="tvd-bucket justify-center flex flex-col gap-6 p-6">
        <ng-container *ngIf="makingSelectionsState">
            <ng-container
                *ngTemplateOutlet="selectionState;
                context: {
                    label: groupTitle,
                    class: groupTitle + '-selection-state',
                    selected: isGroupSelected,
                    toggleFunction: toggleBucketSelection.bind(this),
                    countFunction: countDisplayedMetrics.bind(this)
                }">
            </ng-container>
        </ng-container>

        <div class="no-data-container text-center items-center w-full" *ngIf="countDisplayedMetrics()==0">
            <div class="subtitle">No Data Available</div>
        </div>
        <div class="tiles flex">
            <!-- Composite Tiles on the left side -->
            <div class="composite-eroi-tiles flex " [ngClass]="isDataZeroOrEmpty(getComponentData('solid_waste')) ? '': 'pr-6'">
                <composite-eroi-metric
                    id="solid_waste"
                    [groupId]="groupId"
                    *ngIf="shouldShowCompositeMetric && !isDataZeroOrEmpty(getComponentData('solid_waste'))"
                    [data]="getSubComponentsData('solid_waste')"
                    [makingSelectionsState]="makingSelectionsState"
                >
                    <eroi-metric
                        id="plastic_waste"
                        *ngIf="!isDataZeroOrEmpty(getComponentData('plastic_waste'))"
                        [metricId]="'plastic_waste'"
                        [groupId]="groupId"
                        [data]="getComponentData('plastic_waste')"
                        [brandGroup]="brandGroup"
                        [brands]="brands"
                        [isSubComponent]="true"
                        [makingSelectionsState]="makingSelectionsState"
                        [measurementSystem]="measurementSystem"
                    />
                    <eroi-metric
                        id="cardboard_waste"
                        *ngIf="!isDataZeroOrEmpty(getComponentData('cardboard_waste'))"
                        [metricId]="'cardboard_waste'"
                        [groupId]="groupId"
                        [data]="getComponentData('cardboard_waste')"
                        [brandGroup]="brandGroup"
                        [brands]="brands"
                        [isSubComponent]="true"
                        [makingSelectionsState]="makingSelectionsState"
                        [measurementSystem]="measurementSystem"
                    />
                </composite-eroi-metric>
            </div>

            <div class="flex flex-wrap w-full items-stretch content-start gap-6">
                <ng-container
                *ngFor="let metric of metricData">

                    <!-- Exclude composite metrics and their respective subcomponents from this container-->
                    <eroi-metric
                        *ngIf="!(metricIsCompositeMetric(metric.id) || metricIsCompositeSubComponent(metric.id))"
                        id = {{metric.id}}
                        [metricId] = metric.id
                        [groupId]="groupId"
                        [data] = metric
                        [brandGroup]="brandGroup"
                        [brands]="brands"
                        [makingSelectionsState]="makingSelectionsState"
                        [measurementSystem]="measurementSystem"
                    ></eroi-metric>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Selection state template for Refreshed UI-->
<ng-template
    #selectionState
    let-label="label"
    let-class="class"
    let-selected="selected"
    let-toggleFunction="toggleFunction"
    let-countFunction="countFunction"
>
    <div class="{{class}} w-full flex justify-between items-center pb-4" [ngClass]="countFunction() > 0 ? 'neptune-border-b-1 border-sky-blue' : ''">
        <span class="text-2xl">{{ label }}</span>
        <ng-container *ngIf="countFunction() > 0">
            <button class="add-entire-value-pillar-button" (click)="toggleFunction()" [ngClass]="!selected ? 'neptune-button-white' : 'neptune-button-blue'">
                <ng-container *ngIf="!selected; else addedButton">
                    Add
                    <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" />
                </ng-container>
                <ng-template #addedButton>
                    Added
                    <img src="assets/shared-icons/neptune-icon-white-tick.svg" />
                </ng-template>
            </button>
        </ng-container>
        <ng-container *ngIf="countFunction()==0">
            <span class="text-base italic">No Data Available</span>
        </ng-container>
    </div>
 </ng-template>
